export const ViewMode = {
    List: 'list',
    Edit: 'edit',
    Detail: 'detail',
};

export const ORGANIZATION_MAP_INFO_RECEIVE = 'ORGANIZATION_MAP_INFO_RECEIVE';
export const ORGANIZATION_MAP_INFO_ERROR = 'ORGANIZATION_MAP_INFO_ERROR';
export const ORGANIZATION_MAP_INFO_CHANGE_MODE = 'ORGANIZATION_MAP_INFO_CHANGE_MODE';